/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */

import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, SelectControl, TextControl } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { setAttributes, attributes } = props;
	const { layoutType, patternSlug, cardLayout } = attributes;
	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<InspectorControls>
					
					<PanelBody title={__('Layout', 'wp-travel-blocks')}>

						<SelectControl
							label={__('Select Layout', 'wp-travel-blocks')}
							value={ layoutType }
							options={ [
								{
									label: __('Default Layout', 'wp-travel-blocks'),
									value:'default-layout'
								},
								{
									label: __('Layout One', 'wp-travel-blocks'),
									value:'layout-one'
								}, {
									label: __('Layout Two', 'wp-travel-blocks'),
									value:'layout-two'
								}, {
									label: __('Layout Three', 'wp-travel-blocks'),
									value:'layout-three'
								}, {
									label: __('Layout Four', 'wp-travel-blocks'),
									value:'layout-four'
								}, {
									label: __('Custom Layout', 'wp-travel-blocks'),
									value:'custom'
								}
							] || [
								{
									label: __('Layout One', 'wp-travel-blocks'),
									value:'layout-one'
								}, {
									label: __('Layout Two', 'wp-travel-blocks'),
									value:'layout-two'
								}, {
									label: __('Layout Three', 'wp-travel-blocks'),
									value:'layout-three'
								}, {
									label: __('Layout Four', 'wp-travel-blocks'),
									value:'layout-four'
								}
							] }
							onChange={ (val) => setAttributes( { layoutType: val } ) }
						/>
						{
							layoutType == 'custom' &&
							<TextControl
								label="Pattern Slug"
								value={patternSlug}
								onChange={ value => setAttributes(
									{
										patternSlug: value
									}
								) }
							/>
							||
							<>
								{ layoutType != 'default-layout' && 
									<SelectControl
										label={__('Card Layout', 'wp-travel-blocks')}
										value={ cardLayout }
										options={ [
											{
												label: __('Grid', 'wp-travel-blocks'),
												value:'grid-view'
											},{
												label: __('List', 'wp-travel-blocks'),
												value:'list-view'
											}
										] }
										onChange={ (val) => setAttributes( { cardLayout: val } ) }
									/>
								}
							</>
						}
						
						
						
					</PanelBody>
				</InspectorControls>
			</Fragment>
			<ServerSideRender
				block="wp-travel-blocks/guide-featured-trip"
				attributes={ props.attributes }
			/>
		</div>
	);
}
